export const translations = {
  de: {
    nav: {
      home: "Startseite",
      search: "Suche",
      directory: "Verzeichnis",
      trauerspruch: "Trauersprüche",
      trauerspruch_footer: "Trauerspruch-Generator",
      login: "Anmelden",
      register: "Registrieren",
      dashboard: "Mein Bereich",
      logout: "Abmelden",
      admin: "Admin",
      create_inserat: "Todesanzeige erfassen",
    },
    hero: {
      title: "Erinnerung bewahren. Leben würdigen.",
      subtitle: "Weil jedes Leben eine Geschichte trägt.",
      search_placeholder: "Name oder Ort suchen...",
      search_button: "Suchen",
    },
    home: {
      recent: "Kürzlich Verstorbene",
      featured: "Besondere Gedenken",
      view_all: "Alle anzeigen",
      no_results: "Keine Einträge vorhanden",
      total_inserate: "Anzeigen total",
      this_month: "Letzte 30 Tage",
      personalities: "Persönlichkeiten",
      discover_all: "Alle entdecken",
    },
    vip: {
      hero_title: "Im Gedenken an prägende Schweizer Persönlichkeiten",
      hero_subtitle: "In Erinnerung an Menschen, die durch ihr Wirken Spuren hinterlassen haben. Ihre Leistungen und ihr Einfluss reichen über ihre Lebenszeit hinaus und prägen unser Land bis heute.",
      personality_singular: "Persönlichkeit",
      personality_plural: "Persönlichkeiten",
      no_entries: "Noch keine VIP-Einträge vorhanden.",
      no_entries_period: "Keine Einträge für den Zeitraum",
    },
    ereignisse: {
      title: "Ereignisse",
      subtitle: "Gedenkstätten für historische Ereignisse – Katastrophen, Unglücke und prägende Momente der Schweizer Geschichte.",
      badge: "Ereignis",
      tote: "Todesopfer",
      tote_label: "Tote",
      datum: "Datum",
      ort: "Ort",
      land: "Land",
      kanton: "Kanton",
      wikipedia: "Wikipedia",
      no_entries: "Noch keine Ereignisse vorhanden.",
      no_entries_period: "Keine Ereignisse für den Zeitraum",
      all_periods: "Alle Zeiträume",
      before_1900: "Vor 1900",
      period_1900_1950: "1900–1950",
      period_1951_2000: "1951–2000",
      period_2001: "Ab 2001",
    },
    favorites: {
      title: "Meine Favoriten",
      subtitle: "Gespeicherte Trauersprüche – mit einem Klick wieder verwenden oder anpassen.",
      back_to_generator: "Zurück zum Generator",
      to_generator: "Zum Generator",
      login_required: "Bitte melde dich an, um deine Favoriten zu sehen.",
      login: "Anmelden",
      saved_on: "Gespeichert am",
      person_settings: "Person & Einstellungen",
      use_prompt: "Prompt verwenden / anpassen",
      copy: "Kopieren",
      copied: "Kopiert",
      delete: "Löschen",
      no_title: "Noch keine Favoriten gespeichert",
      no_hint: "Klicke beim Generieren auf das Herz-Symbol, um Sprüche zu speichern.",
      count_singular: "1 gespeicherter Spruch",
      count_plural: "gespeicherte Sprüche",
    },
    search: {
      title: "Suche",
      filters: "Filter",
      kanton: "Kanton",
      all_cantons: "Alle Kantone",
      entry_type: "Eintragsart",
      all_types: "Alle Typen",
      date_from: "Von",
      date_to: "Bis",
      reset: "Zurücksetzen",
      results: "Ergebnisse",
      no_results: "Keine Ergebnisse gefunden",
      of: "von",
      zodiac: "Sternzeichen",
      all_zodiac: "Alle Sternzeichen",
      sort_by: "Sortieren:",
    },
    memorial: {
      born: "Geboren",
      died: "Verstorben",
      age: "Alter",
      years: "Jahre",
      residence: "Wohnort",
      hometown: "Heimatort",
      canton: "Kanton",
      nationality: "Nationalität",
      biography: "Biografie",
      official_notice: "Publiziert",
      achievements: "Leistungen und Vermächtnis",
      wikipedia: "Wikipedia",
      read_article: "Artikel lesen",
      cause_of_death: "Angaben zum Ableben",
      views: "Besuche",
      candles: "Kerzen",
      condolence_title: "Gedenken & Kondolieren",
      condolence_desc: "Zünden Sie eine Kerze an oder hinterlassen Sie eine persönliche Nachricht für die Angehörigen.",
      condolence_btn: "Kerze anzünden & Kondolieren",
      claim: "Inserat beanspruchen",
      claim_info: "Sind Sie ein Angehöriger? Beanspruchen Sie dieses Inserat, um es in ein persönliches Gedenkprofil zu verwandeln.",
      claimed: "Von der Familie betreut",
      claimed_badge: "Von der Familie betreut",
      edit_btn: "Inserat bearbeiten",
      claim_pending: "Anfrage wird geprüft",
      zodiac: "Sternzeichen",
      profession: "Beruf",
      share: "Teilen",
      link_copied: "Link kopiert",
      copy_link: "Link kopieren",
      donate_title: "Unterstützen Sie unsere Arbeit",
      donate_desc: "Verstorben.ch finanziert sich hauptsächlich durch Spenden. Vielen Dank für Ihre Unterstützung.",
      donate_btn: "Jetzt spenden",
    },
    claim_form: {
      title: "Gedenkseite beanspruchen",
      intro: "Möchten Sie die Erinnerung an {name} aktiv mitgestalten? Als verifizierter Angehöriger können Sie diesen Eintrag übernehmen, die Biografie vervollständigen und einen geschützten Raum für Kondolenzen schaffen.",
      relationship: "Ihre Beziehung",
      relationship_options: {
        partner: "Partner/in",
        child: "Kind",
        parent: "Elternteil",
        sibling: "Geschwister",
        grandchild: "Enkel/in",
        authorized: "Bevollmächtigte/r",
      },
      message: "Nachricht an Redaktion",
      message_placeholder: "Erzählen Sie uns kurz, warum Sie diesen Eintrag verwalten möchten. Dies hilft uns, die Echtheit der Anfrage zu bestätigen.",
      document: "Verifizierungs-Dokument",
      document_info: "Um die Pietät zu wahren, prüfen wir jede Anfrage manuell. Ein Foto eines Dokuments (z.B. Familienbüchlein, Vollmacht oder Ausweis) beschleunigt den Prozess.",
      submit: "Anfrage einreichen",
      success: "Ihre Anfrage wurde eingereicht und wird geprüft.",
      select_relationship: "Bitte wählen Sie Ihre Beziehung",
    },
    auth: {
      login_title: "Willkommen zurück",
      login_subtitle: "Melden Sie sich an",
      register_title: "Konto erstellen",
      register_subtitle: "Registrieren Sie sich bei verstorben.ch",
      email: "E-Mail",
      password: "Passwort",
      name: "Vollständiger Name",
      login_button: "Anmelden",
      register_button: "Registrieren",
      google_login: "Mit Google anmelden",
      or: "oder",
      no_account: "Noch kein Konto?",
      has_account: "Bereits ein Konto?",
    },
    dashboard: {
      title: "Mein Bereich",
      claimed: "Meine Todesanzeigen",
      no_claimed: "Sie haben noch keine Inserate beansprucht oder erstellt",
      profile: "Profil",
      role: "Rolle",
      create_btn: "Neue Todesanzeige erfassen",
      edit_btn: "Bearbeiten",
      view_btn: "Ansehen",
    },
    inserat_erstellen: {
      title: "Todesanzeige erfassen",
      subtitle: "Erfassen Sie eine neue Todesanzeige. Sie werden automatisch als verantwortliche Person eingetragen.",
      step1_title: "Personalien",
      step2_title: "Bild & Biografie",
      step3_title: "Bestätigung",
      vorname: "Vorname",
      nachname: "Nachname",
      geburtsdatum: "Geburtsdatum",
      sterbedatum: "Sterbedatum",
      wohnort: "Wohnort",
      kanton: "Kanton",
      kanton_placeholder: "Kanton wählen...",
      biografie: "Biografie / Nachruf",
      biografie_placeholder: "Erzählen Sie vom Leben dieser Person...",
      bild: "Profilbild",
      bild_upload: "Bild hochladen",
      bild_uploading: "Wird hochgeladen...",
      next: "Weiter",
      back: "Zurück",
      submit: "Todesanzeige erfassen",
      submitting: "Wird gespeichert...",
      success_title: "Todesanzeige erfasst",
      success_text: "Die Todesanzeige wurde erfolgreich erstellt.",
      view_memorial: "Gedenkseite ansehen",
      required: "Pflichtfeld",
      error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    },
    inserat_bearbeiten: {
      title: "Inserat bearbeiten",
      subtitle: "Passen Sie die Angaben zu dieser Todesanzeige an.",
      save: "Änderungen speichern",
      saving: "Wird gespeichert...",
      saved: "Gespeichert",
      error: "Fehler beim Speichern",
      back: "Zurück zur Gedenkseite",
    },
    directory: {
      title: "Dienstleister-Verzeichnis",
      subtitle: "Finden Sie Bestatter, Floristen und weitere Dienstleister in Ihrer Region",
      category: "Kategorie",
      all_categories: "Alle Kategorien",
      whole_switzerland: "Ganze Schweiz",
      no_results: "Keine Dienstleister gefunden",
      website: "Webseite",
      phone: "Telefon",
    },
    footer: {
      about: "Über uns",
      privacy: "Datenschutz",
      terms: "Nutzungsbedingungen",
      contact: "Kontakt",
      copyright: "Todesanzeigen. Erinnerung bewahren. Leben würdigen.",
      donate_coffee: "Spende uns einen Kaffee",
    },
    kontakt: {
      title: "Kontakt",
      subtitle: "Haben Sie eine Frage oder ein Anliegen? Schreiben Sie uns.",
      name: "Name",
      email: "E-Mail-Adresse",
      betreff: "Betreff",
      betreff_allgemein: "Allgemeine Anfrage",
      betreff_inserat: "Inserat",
      betreff_technisch: "Technisches Problem",
      betreff_anderes: "Anderes",
      betreff_placeholder: "Bitte wählen...",
      nachricht: "Nachricht",
      nachricht_placeholder: "Ihre Nachricht...",
      submit: "Nachricht senden",
      submitting: "Wird gesendet...",
      success_title: "Nachricht gesendet",
      success_text: "Vielen Dank! Wir melden uns so bald wie möglich bei Ihnen.",
      error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      required: "Pflichtfeld",
    },
    donate: {
      title: "Spende uns einen Kaffee",
      subtitle: "Unterstützen Sie die Entwicklung und den Betrieb von verstorben.ch",
      select_amount: "Betrag wählen",
      custom_placeholder: "Eigener Betrag",
      custom_amount: "CHF",
      donate_button: "Jetzt spenden",
      processing: "Wird verarbeitet...",
      success_title: "Vielen Dank!",
      success_message: "Ihre Spende hilft uns, verstorben.ch weiterzuentwickeln und zu betreiben.",
      back_home: "Zurück zur Startseite",
      error_message: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    },
    types: {
      amtlich: "Amtlich",
      prominent: "Prominent",
      premium: "Premium",
      persoenlichkeit: "Persönlichkeit",
      publiziert: "Publiziert",
      individuell: "Individuell",
    },
    common: {
      loading: "Laden...",
      error: "Ein Fehler ist aufgetreten",
      back: "Zurück",
      save: "Speichern",
      cancel: "Abbrechen",
    },
    trauerspruch: {
      title: "Trauerspruch-Generator",
      subtitle: "Persönliche Trauersprüche – würdevoll, diskret und individuell.",
      free_generation: "1 kostenlose Generierung ohne Anmeldung",
      credits_loading: "Lade...",
      credits_singular: "Kredit verfügbar",
      credits_plural: "Kredits verfügbar",
      buy_credits: "Kredits kaufen",
      my_favorites: "Meine Favoriten",
      section_person: "Angaben zur verstorbenen Person",
      section_style: "Stil & Format",
      label_relationship: "Beziehung",
      label_name: "Name",
      label_name_optional: "(optional)",
      label_gender: "Geschlecht",
      label_traits: "3 Eigenschaften",
      label_traits_hint: "(z.B. warmherzig, humorvoll, hilfsbereit)",
      trait_1: "Eigenschaft 1",
      trait_2: "Eigenschaft 2",
      trait_3: "Eigenschaft 3",
      label_topics: "Wichtige Themen",
      label_topics_hint: "(optional, mehrere möglich)",
      label_exclude: "Was soll NICHT vorkommen?",
      label_exclude_hint: "(optional)",
      placeholder_exclude: "z.B. kein Himmel, kein Gott, nicht kitschig",
      label_tone: "Ton",
      label_language: "Sprache",
      label_channel: "Zweck / Format",
      label_length: "Länge",
      label_length_hint: "(passt sich dem Format an)",
      label_religious: "Religiöser Modus",
      religious_on: "Religiöse Begriffe erlaubt",
      religious_off: "Religiöse Begriffe ausgeschlossen",
      label_variants: "Varianten",
      label_styles: "Stile",
      label_kondolenz: "Kondolenz-Satz an Angehörige einschliessen",
      rel_Mutter: "Mutter", rel_Vater: "Vater", rel_Partner: "Partner:in",
      rel_Kind: "Kind", rel_Freund: "Freund:in", rel_Kolleg: "Kolleg:in", rel_Sonstiges: "Sonstiges",
      gender_Mann: "Mann", gender_Frau: "Frau", gender_Divers: "Divers",
      topic_Familie: "Familie", topic_Glaube: "Glaube", topic_Natur: "Natur",
      topic_Musik: "Musik", topic_Sport: "Sport", topic_Beruf: "Beruf", topic_Krankheit: "Krankheit",
      tone_Wuerdvoll: "Würdevoll", tone_Troestend: "Tröstend", tone_Modern: "Modern",
      tone_Poetisch: "Poetisch", tone_Religios: "Religiös", tone_Schlicht: "Schlicht",
      tone_Formell: "Formell (Sie)", tone_Informell: "Informell (Du)",
      ch_Karte: "Karte", ch_WhatsApp: "WhatsApp", ch_Rede: "Rede",
      ch_Todesanzeige: "Todesanzeige", ch_Kerze: "Kerze-Kondolenz", ch_Email: "E-Mail",
      len_Kurz: "Kurz", len_hint_Kurz: "1–2 Sätze",
      len_Mittel: "Mittel", len_hint_Mittel: "3–5 Sätze",
      len_Lang: "Lang", len_hint_Lang: "6–10 Sätze",
      style_1: "Klassisch", style_2: "Klassisch + Modern", style_3: "Klassisch + Modern + Poetisch",
      style_Klassisch: "Klassisch", style_Modern: "Modern", style_Poetisch: "Poetisch",
      variants_one: "Variante", variants_many: "Varianten",
      generating: "KI generiert Sprüche...",
      generate_one: "Spruch generieren",
      generate_many: "Sprüche generieren",
      label_free: "(kostenlos)",
      label_credit: "– 1 Kredit",
      free_used: "Du hast deine kostenlose Generierung verwendet. Melde dich an und kaufe Kredits für weitere Sprüche.",
      login: "Anmelden",
      no_credits: "Keine Kredits mehr. Kaufe ein Paket um weiterzumachen.",
      result_one: "Dein Trauerspruch",
      result_many: "Trauersprüche",
      copy: "Kopieren", copied: "Kopiert!",
      favorite: "Favorit", saved: "Gespeichert",
      regenerate: "Neu generieren",
      regenerate_all: "Alle neu generieren (1 Kredit)",
      variant_label: "Variante",
      how_it_works: "So funktioniert's",
      info_free: "1 kostenlose Generierung ohne Anmeldung (inkl. mehrere Varianten & Stile)",
      info_credits: "Anmelden & Kredits kaufen für mehr Generierungen",
      info_favorites: "Favoriten speichern im Benutzerprofil",
      login_register: "Anmelden / Registrieren",
      view_prices: "Preise ansehen",
      modal_title: "Kredits kaufen",
      modal_subtitle: "1 Kredit = 1 Generierung (inkl. Varianten & Stile). Wähle dein Paket:",
      payment_info: "Sichere Zahlung via Stripe. Einmalige Zahlung, kein Abo.",
      popular: "Beliebt",
      per_generation: "/ Generierung",
      redirecting: "Weiterleitung...",
      buy: "Kaufen",
      no_packages: "Keine Pakete verfügbar.",
      err_no_credits: "Nicht genug Kredits.",
      err_unavailable: "KI-Generierung momentan nicht verfügbar.",
      err_network: "Server nicht erreichbar. Bitte Seite neu laden und erneut versuchen.",
      buy_now: "Jetzt kaufen",
      pkg_singular: "Spruch",
      pkg_plural: "Sprüche",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      search: "Recherche",
      directory: "Annuaire",
      trauerspruch: "Condoléances",
      trauerspruch_footer: "Générateur de condoléances",
      login: "Connexion",
      register: "S'inscrire",
      dashboard: "Mon espace",
      logout: "Déconnexion",
      admin: "Admin",
      create_inserat: "Publier un avis de décès",
    },
    hero: {
      title: "Préserver les souvenirs. Honorer les vies.",
      subtitle: "Parce que chaque vie porte une histoire.",
      search_placeholder: "Rechercher un nom ou un lieu...",
      search_button: "Rechercher",
    },
    home: {
      recent: "Récemment décédés",
      featured: "Hommages spéciaux",
      view_all: "Tout afficher",
      no_results: "Aucune entrée disponible",
      total_inserate: "Annonces au total",
      this_month: "30 derniers jours",
      personalities: "Personnalités",
      discover_all: "Découvrir tout",
    },
    vip: {
      hero_title: "En mémoire des personnalités marquantes de Suisse",
      hero_subtitle: "En souvenir de personnes qui ont laissé leur empreinte par leur action. Leurs réalisations et leur influence dépassent leur durée de vie et façonnent notre pays encore aujourd'hui.",
      personality_singular: "Personnalité",
      personality_plural: "Personnalités",
      no_entries: "Aucune entrée VIP disponible.",
      no_entries_period: "Aucune entrée pour la période",
    },
    ereignisse: {
      title: "Événements",
      subtitle: "Mémoriaux pour les événements historiques – catastrophes, accidents et moments marquants de l'histoire suisse.",
      badge: "Événement",
      tote: "Victimes",
      tote_label: "Morts",
      datum: "Date",
      ort: "Lieu",
      land: "Pays",
      kanton: "Canton",
      wikipedia: "Wikipedia",
      no_entries: "Aucun événement disponible.",
      no_entries_period: "Aucun événement pour la période",
      all_periods: "Toutes les périodes",
      before_1900: "Avant 1900",
      period_1900_1950: "1900–1950",
      period_1951_2000: "1951–2000",
      period_2001: "Dès 2001",
    },
    favorites: {
      title: "Mes favoris",
      subtitle: "Messages de condoléances enregistrés – réutilisables en un clic.",
      back_to_generator: "Retour au générateur",
      to_generator: "Au générateur",
      login_required: "Veuillez vous connecter pour voir vos favoris.",
      login: "Se connecter",
      saved_on: "Enregistré le",
      person_settings: "Personne & paramètres",
      use_prompt: "Utiliser / adapter la demande",
      copy: "Copier",
      copied: "Copié",
      delete: "Supprimer",
      no_title: "Aucun favori enregistré",
      no_hint: "Cliquez sur le cœur lors de la génération pour sauvegarder des phrases.",
      count_singular: "1 phrase enregistrée",
      count_plural: "phrases enregistrées",
    },
    search: {
      title: "Recherche",
      filters: "Filtres",
      kanton: "Canton",
      all_cantons: "Tous les cantons",
      entry_type: "Type d'entrée",
      all_types: "Tous les types",
      date_from: "Du",
      date_to: "Au",
      reset: "Réinitialiser",
      results: "Résultats",
      no_results: "Aucun résultat trouvé",
      of: "de",
      zodiac: "Signe du zodiaque",
      all_zodiac: "Tous les signes",
      sort_by: "Trier :",
    },
    memorial: {
      born: "Né(e)",
      died: "Décédé(e)",
      age: "Âge",
      years: "ans",
      residence: "Domicile",
      hometown: "Lieu d'origine",
      canton: "Canton",
      nationality: "Nationalité",
      biography: "Biographie",
      official_notice: "Publié",
      achievements: "Réalisations et héritage",
      wikipedia: "Wikipedia",
      read_article: "Lire l'article",
      cause_of_death: "Informations sur le décès",
      views: "Visites",
      candles: "Bougies",
      condolence_title: "Commémoration et condoléances",
      condolence_desc: "Allumez une bougie ou laissez un message personnel pour les proches.",
      condolence_btn: "Allumer une bougie et condoléances",
      claim: "Revendiquer l'annonce",
      claim_info: "Êtes-vous un proche? Revendiquez cette annonce pour en faire un profil commémoratif personnel.",
      claimed: "Revendiqué",
      claim_pending: "Demande en cours d'examen",
      zodiac: "Signe du zodiaque",
      profession: "Profession",
      share: "Partager",
      link_copied: "Lien copié",
      copy_link: "Copier le lien",
      donate_title: "Soutenez notre travail",
      donate_desc: "Verstorben.ch se finance principalement par des dons. Merci pour votre soutien.",
      donate_btn: "Faire un don",
    },
    claim_form: {
      title: "Revendiquer la page commémorative",
      intro: "Souhaitez-vous façonner activement la mémoire de {name}? En tant que proche vérifié, vous pouvez reprendre cette entrée, compléter la biographie et créer un espace protégé pour les condoléances.",
      relationship: "Votre relation",
      relationship_options: {
        partner: "Partenaire",
        child: "Enfant",
        parent: "Parent",
        sibling: "Frère/Sœur",
        grandchild: "Petit-enfant",
        authorized: "Personne autorisée",
      },
      message: "Message à la rédaction",
      message_placeholder: "Expliquez-nous brièvement pourquoi vous souhaitez gérer cette entrée. Cela nous aide à confirmer l'authenticité de la demande.",
      document: "Document de vérification",
      document_info: "Pour préserver la dignité, nous examinons chaque demande manuellement. Une photo d'un document (livret de famille, procuration ou pièce d'identité) accélère le processus.",
      submit: "Soumettre la demande",
      success: "Votre demande a été soumise et sera examinée.",
      select_relationship: "Veuillez sélectionner votre relation",
    },
    auth: {
      login_title: "Bienvenue",
      login_subtitle: "Connectez-vous à votre compte",
      register_title: "Créer un compte",
      register_subtitle: "Inscrivez-vous sur verstorben.ch",
      email: "E-mail",
      password: "Mot de passe",
      name: "Nom complet",
      login_button: "Se connecter",
      register_button: "S'inscrire",
      google_login: "Se connecter avec Google",
      or: "ou",
      no_account: "Pas encore de compte ?",
      has_account: "Déjà un compte ?",
    },
    dashboard: {
      title: "Mon espace",
      claimed: "Annonces revendiquées",
      no_claimed: "Vous n'avez encore revendiqué aucune annonce",
      profile: "Profil",
      role: "Rôle",
    },
    directory: {
      title: "Annuaire des prestataires",
      subtitle: "Trouvez des pompes funèbres, fleuristes et autres prestataires dans votre région",
      category: "Catégorie",
      all_categories: "Toutes les catégories",
      whole_switzerland: "Toute la Suisse",
      no_results: "Aucun prestataire trouvé",
      website: "Site web",
      phone: "Téléphone",
    },
    footer: {
      about: "À propos",
      privacy: "Confidentialité",
      terms: "Conditions d'utilisation",
      contact: "Contact",
      copyright: "verstorben.ch - Le portail commémoratif suisse",
      donate_coffee: "Offrez-nous un café",
    },
    kontakt: {
      title: "Contact",
      subtitle: "Vous avez une question ou une demande ? Écrivez-nous.",
      name: "Nom",
      email: "Adresse e-mail",
      betreff: "Sujet",
      betreff_allgemein: "Demande générale",
      betreff_inserat: "Annonce",
      betreff_technisch: "Problème technique",
      betreff_anderes: "Autre",
      betreff_placeholder: "Veuillez choisir...",
      nachricht: "Message",
      nachricht_placeholder: "Votre message...",
      submit: "Envoyer le message",
      submitting: "Envoi en cours...",
      success_title: "Message envoyé",
      success_text: "Merci ! Nous vous répondrons dans les meilleurs délais.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
      required: "Champ obligatoire",
    },
    donate: {
      title: "Offrez-nous un café",
      subtitle: "Soutenez le développement et le fonctionnement de verstorben.ch",
      select_amount: "Choisir le montant",
      custom_placeholder: "Montant personnalisé",
      custom_amount: "CHF",
      donate_button: "Faire un don",
      processing: "Traitement en cours...",
      success_title: "Merci beaucoup!",
      success_message: "Votre don nous aide à développer et à maintenir verstorben.ch.",
      back_home: "Retour à l'accueil",
      error_message: "Une erreur est survenue. Veuillez réessayer.",
    },
    types: {
      amtlich: "Officiel",
      prominent: "Prominent",
      premium: "Premium",
      persoenlichkeit: "Personnalité",
      publiziert: "Publié",
      individuell: "Individuel",
    },
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      back: "Retour",
      save: "Enregistrer",
      cancel: "Annuler",
    },
    trauerspruch: {
      title: "Générateur de messages de condoléances",
      subtitle: "Messages personnels – avec dignité, discrétion et authenticité.",
      free_generation: "1 génération gratuite sans inscription",
      credits_loading: "Chargement...",
      credits_singular: "crédit disponible",
      credits_plural: "crédits disponibles",
      buy_credits: "Acheter des crédits",
      my_favorites: "Mes favoris",
      section_person: "Informations sur la personne décédée",
      section_style: "Style et format",
      label_relationship: "Relation",
      label_name: "Prénom",
      label_name_optional: "(optionnel)",
      label_gender: "Genre",
      label_traits: "3 caractéristiques",
      label_traits_hint: "(p.ex. chaleureux, humoriste, serviable)",
      trait_1: "Caractéristique 1",
      trait_2: "Caractéristique 2",
      trait_3: "Caractéristique 3",
      label_topics: "Thèmes importants",
      label_topics_hint: "(optionnel, plusieurs possibles)",
      label_exclude: "Qu'est-ce qui ne doit PAS apparaître?",
      label_exclude_hint: "(optionnel)",
      placeholder_exclude: "p.ex. pas de paradis, pas de Dieu, pas de kitsch",
      label_tone: "Ton",
      label_language: "Langue",
      label_channel: "Objectif / Format",
      label_length: "Longueur",
      label_length_hint: "(s'adapte au format)",
      label_religious: "Mode religieux",
      religious_on: "Termes religieux autorisés",
      religious_off: "Termes religieux exclus",
      label_variants: "Variantes",
      label_styles: "Styles",
      label_kondolenz: "Inclure une phrase de condoléances aux proches",
      rel_Mutter: "Mère", rel_Vater: "Père", rel_Partner: "Partenaire",
      rel_Kind: "Enfant", rel_Freund: "Ami(e)", rel_Kolleg: "Collègue", rel_Sonstiges: "Autre",
      gender_Mann: "Homme", gender_Frau: "Femme", gender_Divers: "Autre",
      topic_Familie: "Famille", topic_Glaube: "Foi", topic_Natur: "Nature",
      topic_Musik: "Musique", topic_Sport: "Sport", topic_Beruf: "Profession", topic_Krankheit: "Maladie",
      tone_Wuerdvoll: "Digne", tone_Troestend: "Réconfortant", tone_Modern: "Moderne",
      tone_Poetisch: "Poétique", tone_Religios: "Religieux", tone_Schlicht: "Simple",
      tone_Formell: "Formel (vous)", tone_Informell: "Informel (tu)",
      ch_Karte: "Carte", ch_WhatsApp: "WhatsApp", ch_Rede: "Discours",
      ch_Todesanzeige: "Avis de décès", ch_Kerze: "Condoléances-bougie", ch_Email: "E-mail",
      len_Kurz: "Court", len_hint_Kurz: "1–2 phrases",
      len_Mittel: "Moyen", len_hint_Mittel: "3–5 phrases",
      len_Lang: "Long", len_hint_Lang: "6–10 phrases",
      style_1: "Classique", style_2: "Classique + Moderne", style_3: "Classique + Moderne + Poétique",
      style_Klassisch: "Classique", style_Modern: "Moderne", style_Poetisch: "Poétique",
      variants_one: "variante", variants_many: "variantes",
      generating: "L'IA génère des phrases...",
      generate_one: "Générer un message",
      generate_many: "Générer des messages",
      label_free: "(gratuit)",
      label_credit: "– 1 crédit",
      free_used: "Vous avez utilisé votre génération gratuite. Connectez-vous et achetez des crédits pour plus de messages.",
      login: "Se connecter",
      no_credits: "Plus de crédits. Achetez un forfait pour continuer.",
      result_one: "Votre message de condoléances",
      result_many: "messages de condoléances",
      copy: "Copier", copied: "Copié!",
      favorite: "Favori", saved: "Enregistré",
      regenerate: "Régénérer",
      regenerate_all: "Tout régénérer (1 crédit)",
      variant_label: "Variante",
      how_it_works: "Comment ça fonctionne",
      info_free: "1 génération gratuite sans inscription (incl. variantes & styles)",
      info_credits: "Se connecter & acheter des crédits pour plus de générations",
      info_favorites: "Sauvegarder les favoris dans le profil",
      login_register: "Se connecter / S'inscrire",
      view_prices: "Voir les tarifs",
      modal_title: "Acheter des crédits",
      modal_subtitle: "1 crédit = 1 génération (incl. variantes & styles). Choisissez votre forfait:",
      payment_info: "Paiement sécurisé via Stripe. Paiement unique, sans abonnement.",
      popular: "Populaire",
      per_generation: "/ génération",
      redirecting: "Redirection...",
      buy: "Acheter",
      no_packages: "Aucun forfait disponible.",
      err_no_credits: "Pas assez de crédits.",
      err_unavailable: "Génération IA momentanément indisponible.",
      err_network: "Serveur inaccessible. Veuillez recharger la page et réessayer.",
      buy_now: "Acheter maintenant",
      pkg_singular: "message",
      pkg_plural: "messages",
    },
  },
  it: {
    nav: {
      home: "Home",
      search: "Ricerca",
      directory: "Elenco",
      trauerspruch: "Condoglianze",
      trauerspruch_footer: "Generatore di condoglianze",
      login: "Accedi",
      register: "Registrati",
      dashboard: "Il mio spazio",
      logout: "Esci",
      admin: "Admin",
      create_inserat: "Pubblica un annuncio",
    },
    hero: {
      title: "Preservare i ricordi. Onorare le vite.",
      subtitle: "Perché ogni vita porta una storia.",
      search_placeholder: "Cercare un nome o un luogo...",
      search_button: "Cercare",
    },
    home: {
      recent: "Recentemente deceduti",
      featured: "Omaggi speciali",
      view_all: "Mostra tutti",
      no_results: "Nessuna voce disponibile",
      total_inserate: "Annunci totali",
      this_month: "Ultimi 30 giorni",
      personalities: "Personalità",
      discover_all: "Scopri tutto",
    },
    vip: {
      hero_title: "In memoria delle personalità svizzere più influenti",
      hero_subtitle: "In ricordo di persone che hanno lasciato un'impronta con il loro operato. Le loro realizzazioni e la loro influenza superano la loro durata di vita e plasmano il nostro paese ancora oggi.",
      personality_singular: "Personalità",
      personality_plural: "Personalità",
      no_entries: "Nessuna voce VIP disponibile.",
      no_entries_period: "Nessuna voce per il periodo",
    },
    ereignisse: {
      title: "Eventi",
      subtitle: "Memoriali per eventi storici – catastrofi, incidenti e momenti significativi della storia svizzera.",
      badge: "Evento",
      tote: "Vittime",
      tote_label: "Morti",
      datum: "Data",
      ort: "Luogo",
      land: "Paese",
      kanton: "Cantone",
      wikipedia: "Wikipedia",
      no_entries: "Nessun evento disponibile.",
      no_entries_period: "Nessun evento per il periodo",
      all_periods: "Tutti i periodi",
      before_1900: "Prima del 1900",
      period_1900_1950: "1900–1950",
      period_1951_2000: "1951–2000",
      period_2001: "Dal 2001",
    },
    favorites: {
      title: "I miei preferiti",
      subtitle: "Messaggi di condoglianze salvati – riutilizzabili con un clic.",
      back_to_generator: "Torna al generatore",
      to_generator: "Al generatore",
      login_required: "Effettua il login per vedere i tuoi preferiti.",
      login: "Accedi",
      saved_on: "Salvato il",
      person_settings: "Persona & impostazioni",
      use_prompt: "Usare / adattare il prompt",
      copy: "Copiare",
      copied: "Copiato",
      delete: "Eliminare",
      no_title: "Nessun preferito salvato",
      no_hint: "Clicca sul cuore durante la generazione per salvare le frasi.",
      count_singular: "1 frase salvata",
      count_plural: "frasi salvate",
    },
    search: {
      title: "Ricerca",
      filters: "Filtri",
      kanton: "Cantone",
      all_cantons: "Tutti i cantoni",
      entry_type: "Tipo di voce",
      all_types: "Tutti i tipi",
      date_from: "Dal",
      date_to: "Al",
      reset: "Ripristinare",
      results: "Risultati",
      no_results: "Nessun risultato trovato",
      of: "di",
      zodiac: "Segno zodiacale",
      all_zodiac: "Tutti i segni",
      sort_by: "Ordina:",
    },
    memorial: {
      born: "Nato/a",
      died: "Deceduto/a",
      age: "Età",
      years: "anni",
      residence: "Domicilio",
      hometown: "Luogo d'origine",
      canton: "Cantone",
      nationality: "Nazionalità",
      biography: "Biografia",
      official_notice: "Pubblicato",
      achievements: "Risultati e lascito",
      wikipedia: "Wikipedia",
      read_article: "Leggi l'articolo",
      cause_of_death: "Informazioni sul decesso",
      views: "Visite",
      candles: "Candele",
      condolence_title: "Commemorazione e condoglianze",
      condolence_desc: "Accendi una candela o lascia un messaggio personale per i familiari.",
      condolence_btn: "Accendi una candela e condoglianze",
      claim: "Rivendicare l'annuncio",
      claim_info: "Sei un parente? Rivendica questo annuncio per trasformarlo in un profilo commemorativo personale.",
      claimed: "Rivendicato",
      claim_pending: "Richiesta in corso di verifica",
      zodiac: "Segno zodiacale",
      profession: "Professione",
      share: "Condividi",
      link_copied: "Link copiato",
      copy_link: "Copia link",
      donate_title: "Sostenete il nostro lavoro",
      donate_desc: "Verstorben.ch si finanzia principalmente tramite donazioni. Grazie per il vostro sostegno.",
      donate_btn: "Dona ora",
    },
    claim_form: {
      title: "Rivendicare la pagina commemorativa",
      intro: "Desideri contribuire attivamente alla memoria di {name}? Come parente verificato, puoi assumere il controllo di questa voce, completare la biografia e creare uno spazio protetto per le condoglianze.",
      relationship: "La tua relazione",
      relationship_options: {
        partner: "Partner",
        child: "Figlio/a",
        parent: "Genitore",
        sibling: "Fratello/Sorella",
        grandchild: "Nipote",
        authorized: "Persona autorizzata",
      },
      message: "Messaggio alla redazione",
      message_placeholder: "Raccontaci brevemente perché desideri gestire questa voce. Questo ci aiuta a confermare l'autenticità della richiesta.",
      document: "Documento di verifica",
      document_info: "Per preservare la dignità, esaminiamo ogni richiesta manualmente. Una foto di un documento (libretto di famiglia, procura o documento d'identità) accelera il processo.",
      submit: "Invia richiesta",
      success: "La tua richiesta è stata inviata e sarà esaminata.",
      select_relationship: "Seleziona la tua relazione",
    },
    auth: {
      login_title: "Bentornato",
      login_subtitle: "Accedi al tuo account",
      register_title: "Crea un account",
      register_subtitle: "Registrati su verstorben.ch",
      email: "E-mail",
      password: "Password",
      name: "Nome completo",
      login_button: "Accedi",
      register_button: "Registrati",
      google_login: "Accedi con Google",
      or: "o",
      no_account: "Non hai ancora un account?",
      has_account: "Hai già un account?",
    },
    dashboard: {
      title: "Il mio spazio",
      claimed: "Annunci rivendicati",
      no_claimed: "Non hai ancora rivendicato nessun annuncio",
      profile: "Profilo",
      role: "Ruolo",
    },
    directory: {
      title: "Elenco fornitori",
      subtitle: "Trova imprese funebri, fioristi e altri fornitori nella tua regione",
      category: "Categoria",
      all_categories: "Tutte le categorie",
      whole_switzerland: "Tutta la Svizzera",
      no_results: "Nessun fornitore trovato",
      website: "Sito web",
      phone: "Telefono",
    },
    footer: {
      about: "Chi siamo",
      privacy: "Privacy",
      terms: "Condizioni d'uso",
      contact: "Contatto",
      copyright: "verstorben.ch - Il portale commemorativo svizzero",
      donate_coffee: "Offrici un caffè",
    },
    kontakt: {
      title: "Contatto",
      subtitle: "Hai una domanda o una richiesta? Scrivici.",
      name: "Nome",
      email: "Indirizzo e-mail",
      betreff: "Oggetto",
      betreff_allgemein: "Richiesta generale",
      betreff_inserat: "Annuncio",
      betreff_technisch: "Problema tecnico",
      betreff_anderes: "Altro",
      betreff_placeholder: "Seleziona...",
      nachricht: "Messaggio",
      nachricht_placeholder: "Il tuo messaggio...",
      submit: "Invia messaggio",
      submitting: "Invio in corso...",
      success_title: "Messaggio inviato",
      success_text: "Grazie! Ti risponderemo il prima possibile.",
      error: "Si è verificato un errore. Riprova.",
      required: "Campo obbligatorio",
    },
    donate: {
      title: "Offrici un caffè",
      subtitle: "Sostieni lo sviluppo e il funzionamento di verstorben.ch",
      select_amount: "Scegli l'importo",
      custom_placeholder: "Importo personalizzato",
      custom_amount: "CHF",
      donate_button: "Dona ora",
      processing: "Elaborazione in corso...",
      success_title: "Grazie mille!",
      success_message: "La tua donazione ci aiuta a sviluppare e mantenere verstorben.ch.",
      back_home: "Torna alla home",
      error_message: "Si è verificato un errore. Riprova.",
    },
    types: {
      amtlich: "Ufficiale",
      prominent: "Prominente",
      premium: "Premium",
      persoenlichkeit: "Personalità",
      publiziert: "Pubblicato",
      individuell: "Individuale",
    },
    common: {
      loading: "Caricamento...",
      error: "Si è verificato un errore",
      back: "Indietro",
      save: "Salva",
      cancel: "Annulla",
    },
    trauerspruch: {
      title: "Generatore di messaggi di condoglianze",
      subtitle: "Messaggi personali – dignitosi, discreti e autentici.",
      free_generation: "1 generazione gratuita senza registrazione",
      credits_loading: "Caricamento...",
      credits_singular: "credito disponibile",
      credits_plural: "crediti disponibili",
      buy_credits: "Acquista crediti",
      my_favorites: "I miei preferiti",
      section_person: "Informazioni sulla persona deceduta",
      section_style: "Stile e formato",
      label_relationship: "Relazione",
      label_name: "Nome",
      label_name_optional: "(opzionale)",
      label_gender: "Genere",
      label_traits: "3 caratteristiche",
      label_traits_hint: "(p.es. caloroso, umoristico, disponibile)",
      trait_1: "Caratteristica 1",
      trait_2: "Caratteristica 2",
      trait_3: "Caratteristica 3",
      label_topics: "Temi importanti",
      label_topics_hint: "(opzionale, più possibili)",
      label_exclude: "Cosa NON deve apparire?",
      label_exclude_hint: "(opzionale)",
      placeholder_exclude: "p.es. niente paradiso, niente Dio, non kitsch",
      label_tone: "Tono",
      label_language: "Lingua",
      label_channel: "Scopo / Formato",
      label_length: "Lunghezza",
      label_length_hint: "(si adatta al formato)",
      label_religious: "Modalità religiosa",
      religious_on: "Termini religiosi consentiti",
      religious_off: "Termini religiosi esclusi",
      label_variants: "Varianti",
      label_styles: "Stili",
      label_kondolenz: "Includere una frase di condoglianze ai familiari",
      rel_Mutter: "Madre", rel_Vater: "Padre", rel_Partner: "Partner",
      rel_Kind: "Figlio/a", rel_Freund: "Amico/a", rel_Kolleg: "Collega", rel_Sonstiges: "Altro",
      gender_Mann: "Uomo", gender_Frau: "Donna", gender_Divers: "Altro",
      topic_Familie: "Famiglia", topic_Glaube: "Fede", topic_Natur: "Natura",
      topic_Musik: "Musica", topic_Sport: "Sport", topic_Beruf: "Professione", topic_Krankheit: "Malattia",
      tone_Wuerdvoll: "Dignitoso", tone_Troestend: "Consolante", tone_Modern: "Moderno",
      tone_Poetisch: "Poetico", tone_Religios: "Religioso", tone_Schlicht: "Semplice",
      tone_Formell: "Formale (Lei)", tone_Informell: "Informale (tu)",
      ch_Karte: "Biglietto", ch_WhatsApp: "WhatsApp", ch_Rede: "Discorso",
      ch_Todesanzeige: "Annuncio di morte", ch_Kerze: "Condoglianze-candela", ch_Email: "E-mail",
      len_Kurz: "Breve", len_hint_Kurz: "1–2 frasi",
      len_Mittel: "Medio", len_hint_Mittel: "3–5 frasi",
      len_Lang: "Lungo", len_hint_Lang: "6–10 frasi",
      style_1: "Classico", style_2: "Classico + Moderno", style_3: "Classico + Moderno + Poetico",
      style_Klassisch: "Classico", style_Modern: "Moderno", style_Poetisch: "Poetico",
      variants_one: "variante", variants_many: "varianti",
      generating: "L'IA genera messaggi...",
      generate_one: "Genera messaggio",
      generate_many: "Genera messaggi",
      label_free: "(gratuito)",
      label_credit: "– 1 credito",
      free_used: "Hai usato la tua generazione gratuita. Accedi e acquista crediti per altri messaggi.",
      login: "Accedi",
      no_credits: "Nessun credito rimasto. Acquista un pacchetto per continuare.",
      result_one: "Il tuo messaggio di condoglianze",
      result_many: "messaggi di condoglianze",
      copy: "Copiare", copied: "Copiato!",
      favorite: "Preferito", saved: "Salvato",
      regenerate: "Rigenerare",
      regenerate_all: "Rigenerare tutto (1 credito)",
      variant_label: "Variante",
      how_it_works: "Come funziona",
      info_free: "1 generazione gratuita senza registrazione (incl. varianti & stili)",
      info_credits: "Accedere & acquistare crediti per più generazioni",
      info_favorites: "Salvare i preferiti nel profilo",
      login_register: "Accedi / Registrati",
      view_prices: "Visualizza prezzi",
      modal_title: "Acquista crediti",
      modal_subtitle: "1 credito = 1 generazione (incl. varianti & stili). Scegli il tuo pacchetto:",
      payment_info: "Pagamento sicuro tramite Stripe. Pagamento unico, nessun abbonamento.",
      popular: "Popolare",
      per_generation: "/ generazione",
      redirecting: "Reindirizzamento...",
      buy: "Acquistare",
      no_packages: "Nessun pacchetto disponibile.",
      err_no_credits: "Crediti insufficienti.",
      err_unavailable: "Generazione IA momentaneamente non disponibile.",
      err_network: "Server non raggiungibile. Ricarica la pagina e riprova.",
      buy_now: "Acquista ora",
      pkg_singular: "messaggio",
      pkg_plural: "messaggi",
    },
  },
};
